"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuLink = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _Text = require("../Text");
var _Truncate = require("../Truncate");
var _SubMenuModule = _interopRequireDefault(require("./SubMenu.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const SubMenuLink = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    menuLinkTitle,
    menuLinkIcon,
    menuLinkIconSize = 'medium',
    menuLinkIconType,
    menuKey,
    selectedMenuKey,
    disabled = false,
    onChange
  } = _ref;
  const isMenuLinkSelected = selectedMenuKey === menuKey;
  const onChangeHandler = () => {
    if (!disabled) {
      onChange && onChange(menuKey);
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      onChangeHandler();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_SubMenuModule.default.subMenuLinkWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_SubMenuModule.default.subMenuLink, {
      [_SubMenuModule.default.highlightedMenu]: isMenuLinkSelected
    }),
    onKeyDown: onKeyDownHandler,
    onClick: onChangeHandler,
    ref: ref,
    tabIndex: disabled ? '-1' : 0
  }, /*#__PURE__*/React.createElement("div", {
    className: _SubMenuModule.default.groupTitleWrapper
  }, !!menuLinkIcon && /*#__PURE__*/React.createElement(_Icon.Icon, {
    color: _Text.TEXT_COLORS.inverseSecondary,
    name: menuLinkIcon,
    size: menuLinkIconSize,
    type: menuLinkIconType,
    className: _SubMenuModule.default.menuLinkIcon
  }), /*#__PURE__*/React.createElement(_Text.ButtonTextMedium, {
    color: _Text.TEXT_COLORS.inverseSecondary,
    className: _SubMenuModule.default.menuLinkTitle
  }, /*#__PURE__*/React.createElement(_Truncate.Truncate, null, menuLinkTitle)))));
});
exports.SubMenuLink = SubMenuLink;